/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Init_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to initialize audio recorder: {error}" |
*
* @param {Audio_Recorder_Init_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_init_failed = /** @type {((inputs: Audio_Recorder_Init_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Init_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'initialisation de l'enregistreur audio : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Initialisieren des Audiorecorders: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile inizializzare il registratore audio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось инициализировать аудиорекордер: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al inicializar la grabadora de audio: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频录制器初始化失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオレコーダーの初期化に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो रिकॉर्डर को प्रारंभ करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao inicializar o gravador de áudio: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to initialize audio recorder: ${i?.error}`)
});